var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlerticonWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "42px",
    viewBox: "0 0 48 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alerticon_warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.3516972,28.0752151 L21.8883384,28.0752151 L20.5945696,11.9088815 L25.6136993,11.9377602 L24.3516972,28.0752151 Z M20.8544785,35.0118949 L25.3884449,35.0118949 L25.3884449,30.4750407 L20.8544785,30.4750407 L20.8544785,35.0118949 Z M45.9501269,37.6860688 L25.2411632,1.31903768 C24.3603608,-0.439679225 21.8479081,-0.439679225 20.9671057,1.31903768 L0.255254138,37.6860688 C-0.53891195,39.2772888 0.616238724,41.1428571 2.39228288,41.1428571 L43.815986,41.1428571 C45.5920302,41.1428571 46.744293,39.2772888 45.9501269,37.6860688 L45.9501269,37.6860688 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1---Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Dashboard-(Medizen)---Log-out-confirmation",
    transform: "translate(-696.000000, -376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vertical-Adjuster",
    transform: "translate(520.000000, 333.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerticon_warning",
    transform: "translate(176.900000, 43.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFC300",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerticonWarning);
export default __webpack_public_path__ + "static/media/alerticon_warning.b0045eaa.svg";
export { ForwardRef as ReactComponent };